/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/member-ordering */
import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, ComponentRef, OnDestroy, Type, ViewChild } from '@angular/core';
import { ModalInsertionDirective } from '@directives/modal-insertion.directive';
import { ModalOverlayStyle, ModalSize } from '@interfaces/common/common.interface';
import { Subject } from 'rxjs';
import { modalAnimation } from './modal-animation';
import { ModalRef } from './modal-ref';
import { ModalConfig } from './modal.config';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  animations: [modalAnimation()]
})
export class ModalComponent implements AfterViewInit, OnDestroy {

  componentRef!: ComponentRef<any>;

  @ViewChild(ModalInsertionDirective)
  insertionPoint!: ModalInsertionDirective;

  size: ModalSize = ModalSize.DEFAULT;
  data: any;
  style: ModalOverlayStyle = 'default';
  childComponentType!: Type<any>;
  dlgOver = false;
  private readonly _onClose = new Subject<any>();
  public onClose = this._onClose.asObservable();

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private cd: ChangeDetectorRef,
    private modalRef: ModalRef,
    public modalConfig: ModalConfig) {
      this.style = this.modalConfig.style || 'default';
      this.data = this.modalConfig.data;
  }

  ngAfterViewInit(): void {
    this.loadChildComponent(this.childComponentType);
    this.cd.detectChanges();

    window.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.keyCode === 27) {
        this.closeDialog();
      }
    });
  }

  onOverlayClicked(evt: MouseEvent): void {
    if (!this.dlgOver && this.modalConfig.closeOnOverlayClick !== false) {
      this.closeDialog();
    }
  }

  onDialogClicked(evt: MouseEvent): void {
    evt.stopPropagation();
  }

  /**
   * Asked before a close the user starts - Escape, the X, an overlay click. A child replaces it to keep
   * itself open, for instance while a request it sent is still writing. close() from code is not asked.
   */
  canClose: () => boolean = () => true;

  closeDialog() {
    if (!this.canClose()) {
      return;
    }
    this.modalRef.close();
  }

  loadChildComponent(componentType: Type<any>): void {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentType);

    const viewContainerRef = this.insertionPoint.viewContainerRef;
    viewContainerRef.clear();

    this.componentRef = viewContainerRef.createComponent(componentFactory);
  }

  ngOnDestroy(): void {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  close<T>(val?: T): void {
    this.modalRef.close(val);
    this._onClose.next(val);
  }
}
